import { createFileRoute } from "@tanstack/react-router"
import { z } from "zod"

import { loadMonitoringConsole } from "@/admin/monitoring/monitoring-console-data"
import { MonitoringConsolePage } from "@/admin/monitoring/page"

const searchSchema = z.object({
  monitoringRunId: z.string().uuid().optional(),
})

const MonitoringConsoleRoute = () => {
  const navigate = Route.useNavigate()
  return (
    <MonitoringConsolePage
      initial={Route.useLoaderData()}
      onSelectRun={(monitoringRunId) =>
        void navigate({ search: { monitoringRunId } })
      }
    />
  )
}

export const Route = createFileRoute("/_terminalAdmin/terminal/admin/runs")({
  validateSearch: searchSchema,
  loaderDeps: ({ search }) => ({ monitoringRunId: search.monitoringRunId }),
  loader: ({ deps }) => loadMonitoringConsole({ data: deps }),
  component: MonitoringConsoleRoute,
})
